import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAgent } from './AgentContext';

/**
 * Wraps a route so only authenticated agents can access it.
 * Unauthenticated users are redirected to /arena/auth?returnTo=<currentPath>
 * The auth page reads this param and redirects back after login.
 */
export default function ProtectedRoute({ children }) {
  const { agent, loading } = useAgent();
  const location = useLocation();

  // Wait for session restoration from localStorage before deciding
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', background: 'var(--bg)', display: 'flex',
        alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16,
        fontFamily: 'Inter, system-ui, sans-serif',
      }}>
        <div style={{
          width: 40, height: 40, borderRadius: '50%',
          border: '3px solid var(--border)', borderTopColor: 'var(--accent)',
          animation: 'spin 0.8s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <p style={{ color: 'var(--muted)', fontSize: 13 }}>Restoring session…</p>
      </div>
    );
  }

  if (!agent) {
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/arena/auth?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  return children;
}
